(function (angular) {
  var m = angular.module("app");

  m.directive("billingAddress", ["STATES", "_", function (STATES, _) {
    return {
      scope: {
        address: "=ngModel",
        ngDisabled: "=",
        ngRequired: "="
      },
      restrict: "E",
      replace: true,
      require: "^form",
      templateUrl: function (element, attrs) {
        return attrs.template || "/app/account/billing_address.html";
      },
      link: function (scope, elem, attrs, form) {
        scope.form = form;

        scope.states = STATES;
        scope.countries = _.uniq(STATES, "country");

        scope.$watch("address.state", function () {
          if (scope.address && scope.address.state != null && scope.address.state !== "") {
            var c = _.find(STATES, {
              abbreviation: scope.address.state
            });
            if (c.country !== scope.address.country) {
              scope.address.country = c.country;
            }
          }
        });

        scope.$watch("address.country", function () {
          if (scope.address && scope.address.state != null && scope.address.state !== "") {
            var c = _.find(STATES, {
              abbreviation: scope.address.state
            });
            if (c.country !== scope.address.country) {
              scope.address.state = "";
            }
          }
        });
      }
    };
  }]);

  // MIT Licensed Credit Card validation: https://gist.github.com/lrvick/8789669
  m.directive("billingInformation", [function () {
    return {
      scope: {
        card: "=ngModel",
        ngDisabled: "=",
        ngRequired: "=",
        cardDirty: "=?"
      },
      restrict: "E",
      replace: true,
      require: "^form",
      templateUrl: "/app/account/billing_information.html",
      link: function (scope, elem, attrs, form) {
        scope.form = form;

        var expirationStartYear = new Date().getFullYear();

        scope.expirationYears = [
          expirationStartYear,
          expirationStartYear + 1,
          expirationStartYear + 2,
          expirationStartYear + 3,
          expirationStartYear + 4,
          expirationStartYear + 5,
          expirationStartYear + 6,
          expirationStartYear + 7,
          expirationStartYear + 8,
          expirationStartYear + 9,
          expirationStartYear + 10
        ];

        attrs.$observe("showErrorsOnLoad", function () {
          scope.showErrorsOnLoad = (attrs.showErrorsOnLoad === "true");
        });

        scope.$watch(function () {
          var number = scope.form.cardNumber.$viewValue || "";
          var name = scope.form.cardName.$viewValue || "";
          var expMonth = scope.form.expirationMonth.$viewValue || "";
          var expYear = scope.form.expirationYear.$viewValue || "";
          var cvv = scope.form.cvv.$viewValue || "";

          return number + "_" + name + "_" + expMonth + "_" + expYear + "_" + cvv;
        }, function (n, o) {
          if (angular.equals(n, o)) return;

          scope.cardDirty = n;
        });
      }
    };
  }]);

  m.directive("cardType", function () {
    return {
      scope: {
        cardType: "="
      },
      require: "ngModel",
      link: function (scope, elm, attrs, ctrl) {
        var initialCardType;

        function getType(value) {
          var type =
            (/^5[1-5]/.test(value)) ? "MasterCard" :
            (/^4/.test(value)) ? "VISA" :
            (/^3[47]/.test(value)) ? "AmEx" :
            undefined;
          return type;
        }

        var unregisterInitialCardType = scope.$watch("cardType", function (n, o) {
          if (angular.equals(n, o)) return;

          // keep track of the original card.  When the card field is empty, we can set the card type to the original card Type.
          initialCardType = n;
          unregisterInitialCardType();
        });

        scope.$watch(function () {
          return ctrl.$viewValue;
        }, function (n, o) {
          if (angular.equals(n, o)) return;

          if (n == null || n == "") scope["cardType"] = initialCardType;
          else scope["cardType"] = getType(n);
        });

        ctrl.$validators["cardType"] = function (modelValue, viewValue) {
          var value = modelValue || viewValue;

          // if value is not set, consider it valid because ng-required attribute will handle this case.
          if (value == null || value == "") return true;

          var type = getType(value);

          return type != null;
        };
      }
    };
  });

  m.directive("cardExpiration", ["moment", function (moment) {
    return {
      scope: {
        cardMonth: "=",
        cardYear: "="
      },
      restrict: "A",
      require: "ngModel",
      link: function (scope, elm, attrs, ctrl) {

        scope.$watchGroup(["cardMonth", "cardYear"], function () {
          ctrl.$validate();
        });

        ctrl.$validators["cardExpiration"] = function () {

          if (scope.cardYear == null || scope.cardMonth == null) return true; // if the necessary fields aren't filled in, don't return a negative validation

          // credit expiration 
          var now = moment();

          var expDate = moment(scope.cardYear + "-" + scope.cardMonth + "-1", "YYYY-MM-DD").endOf("month");

          return expDate.isAfter(now);
        };
      }
    };
  }]);
})(window.angular);



// WEBPACK FOOTER //
// ./app/components/creditCard.directive.js